<template>
  <div class="left_block course-create my-courses">
    <p class="header">
      <router-link :to="'/all-courses'">
        <span> Все курсы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      Конструктор курса
    </p>

    <div class="create_tabs">
      <ul>
        <div class="left_tabs">
          <li :class="activeTab === 0 ? 'is-active' : ''" @click="activeTab = 0">Редактирование курса</li>
          <li :class="activeTab === 1 ? 'is-active' : ''" @click="activeTab = 1">
            Предварительный просмотр курса
          </li>
        </div>
      </ul>
    </div>

    <div class="creation_form" v-if="activeTab === 0">
      <CourseCreateFilter
        @change-photo="changePhoto"
        :disable-buttons="false"
        @click="openCategoriesModal"
        @delete-course="deleteCourse"
        @share-course="shareCourse"
        :fields-changed="fieldsChanged"
        :categories-list="modalCategoriesList"
        @create="saveCourse"
        :new-course="courseInfo"
      />

      <CoursePlan
        @delete="deleteStage"
        @abort="abortStage"
        @submit="addStage"
        :new-stage="newStage"
        :stages-list="stagesList"
        :authors-list="authorsList"
        :course-info="courseInfo"
      />

      <b-modal :active.sync="isModalOpen" has-modal-card scroll="keep" @close="closeCategoriesModal">
        <CategoriesModal @close-modal="closeCategoriesModal" />
      </b-modal>

      <b-modal :active.sync="isLeaveModalOpen" has-modal-card scroll="keep">
        <LeaveModal />
      </b-modal>
    </div>

    <CoursePreview :course-info="courseInfo" :stages-list="stagesList" v-if="activeTab === 1" />

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import CourseCreateFilter from '@/components/admin/all-courses/CourseCreateFilter'
import CoursePlan from '@/components/admin/all-courses/CoursePlan'
import CategoriesModal from '@/components/admin/categories/CategoriesModal'
import CoursePreview from '@/components/admin/all-courses/CoursePreview'
import LeaveModal from '@/components/modal/LeaveModal'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

function blankLessonContent() {
  return {
    comment: '',
    answerType: 1,
    lessonLink: 0,
    lessonLinkType: 0,
    chosenAnswer: '',
    chosenAnswers: [],
    title: '',
    open: false,
    preview: '',
    answersList: [{ text: '', correct: false }]
  }
}
export default {
  components: {
    CourseCreateFilter,
    CoursePlan,
    CategoriesModal,
    CoursePreview,
    LeaveModal
  },
  data() {
    return {
      isLeaveModalOpen: false,
      isModalOpen: false,
      fieldsChanged: {
        name: false,
        leaveAllowed: true
      },
      activeTab: 0,
      oldCourseInfo: {
        name: '',
        description: '',
        category_id: 0,
        days_limit: 1,
        status: 0,
        price: null
      },
      newStage: {
        type: null,
        name: '',
        lesson_content: JSON.stringify([blankLessonContent()])
      },
      isLoading: true,
      authorsList: []
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    stagesList() {
      return this.$store.state.courses.stagesList
    },
    modalCategoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    },
    courseInfo() {
      return this.$store.state.courses.courseInfo
    },
    courseId() {
      return Number(this.$route.params.id)
    }
  },
  mounted() {
    this.loadData()
    this.loadStages()
    window.onbeforeunload = function () {
      return 'Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!'
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      if (to.params.id !== from.params.id) {
        this.loadData()
        this.loadStages()
        window.onbeforeunload = function () {
          return 'Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!'
        }
      }
    }
  },
  beforeDestroy() {
    window.onbeforeunload = ''
  },
  beforeRouteLeave(to, from, next) {
    if (this.fieldsChanged.leaveAllowed) {
      next()
      return
    }
    this.isLeaveModalOpen = true
    this.$nextTick(() => {
      document.getElementById('confirm-leave-btn').addEventListener('click', () => {
        this.isLeaveModalOpen = false
        next()
      })
      document.getElementById('abort-leave-btn').addEventListener('click', () => {
        this.isLeaveModalOpen = false
        next(false)
      })
    })
  },
  methods: {
    loadDataCallback(data) {
      this.$store.commit('setCourseInfo', { list: data })
      this.oldCourseInfo = {}
      Object.keys(data).forEach((key) => {
        this.oldCourseInfo[key] = data[key]
      })
    },
    loadData() {
      this.isLoading = true
      this.$axios2
        .get('courses/' + this.courseId)
        .then((resp) => {
          this.loadDataCallback(resp.data)
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    },
    loadStages() {
      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setStagesList', { list: resp.data })
          this.loadAuthors(resp.data, 0)
          this.isLoading = false
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    },
    loadAuthors(data, index) {
      if (index === Number(data.length) || this.userRole === 'methodist') return
      let stage = data[index]
      let currentAuthorIndex = this.authorsList.findIndex((el) => el.id === stage.user_id)
      if (currentAuthorIndex !== -1) {
        this.authorsList[currentAuthorIndex].stageIds.push(stage.id)
        this.loadAuthors(data, index + 1)
        return
      }
      this.$axios2
        .get('users/' + stage.user_id)
        .then((resp) => {
          this.authorsList.push({
            stageIds: [stage.id],
            name: resp.data.surname + ' ' + resp.data.name,
            id: resp.data.id
          })
        })
        .then(() => {
          this.loadAuthors(data, index + 1)
        })
        .catch(this.$errorToast)
    },
    loadCategories() {
      this.$axios2
        .get('categories')
        .then((resp) => {
          this.$store.commit('setCategoriesList', { list: resp.data })
          this.$axios2
            .get('courses/list?category_id=' + resp.data[0].id)
            .then((response) => {
              this.$store.commit('setCategoryCoursesList', {
                list: response.data,
                index: 0
              })
            })
            .catch(this.$errorToast)
        })
        .catch(this.$errorToast)
      this.$axios2
        .get('categories?all=true')
        .then((resp) => {
          this.$store.commit('setModalCategoriesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    openCategoriesModal() {
      this.isModalOpen = true
    },
    closeCategoriesModal() {
      this.isModalOpen = false
    },
    abortStage() {
      this.newStage = {
        type: null,
        name: ''
      }
    },
    addStage() {
      let request = {
        sort_number: this.stagesList.length,
        name: this.newStage.name,
        type: this.newStage.type,
        description: 'Описание'
      }
      this.$axios2
        .post('courses/' + this.courseId + '/stages', request)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadStages()
          this.abortStage()
        })
        .catch(this.$errorToast)
    },
    deleteStage(stage) {
      this.isLoading = true
      this.$axios2
        .delete('courses/' + this.courseId + '/stages/' + stage.id)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadStages()
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    },
    changePhoto(file) {
      const fData = new FormData()
      fData.append('image', file)
      fData.append('id', this.courseId)
      this.$axios2
        .post('courses/' + this.courseId, fData, { headers: { 'content-type': 'multipart/form-data' } })
        .then((resp) => {
          this.loadDataCallback(resp.data)
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteCourse() {
      this.$axios2
        .delete('courses/' + this.courseId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.fieldsChanged.leaveAllowed = true
          this.$router.push('/all-courses')
          this.loadCategories()
        })
        .catch(this.$errorToast)
    },
    saveCourse() {
      let request = {}
      Object.keys(this.courseInfo).forEach((key) => {
        if (this.courseInfo[key] !== this.oldCourseInfo[key]) {
          request[key] = this.courseInfo[key]
        }
      })
      if (!Object.keys(request).length) {
        return
      }
      this.$axios2
        .post('courses/' + this.courseId, request)
        .then((resp) => {
          this.fieldsChanged.name = false
          this.fieldsChanged.leaveAllowed = true
          this.$buefy.toast.open(toastInfo())
          this.loadDataCallback(resp.data)
          this.loadCategories()
        })
        .catch(this.$errorToast)
    },
    shareCourse(newStatus) {
      if (!this.stagesList.length && newStatus) {
        this.$buefy.toast.open(toastDanger('Нельзя опубликовать курс без урока или теста'))
        return
      }
      this.courseInfo.status = newStatus
      this.saveCourse()
      // if (newStatus) {
      // let correct_tests = 0
      // let all_tests = 0
      // this.stagesList.forEach((stage) => {
      //    if (stage.test_material) {
      //       all_tests++
      //       let questionsList = []
      //       let finalQuestionsList = []
      //       if (Number(stage.type) === 2) {
      //          questionsList = JSON.parse(stage.test_material.content)
      //          if (
      //             questionsList.every((answer) => {
      //                return answer.title.length
      //             })
      //          ) {
      //             correct_tests++
      //          } else {
      //             this.$buefy.toast.open(toastDanger('Нельзя опубликовать курс с пустым тестом'))
      //             isValid = false
      //             return
      //          }
      //       } else if (Number(stage.type) === 3) {
      //          finalQuestionsList = JSON.parse(stage.test_material.content)
      //          if (
      //             finalQuestionsList.every((question) => {
      //                return question.every((answer) => {
      //                   return answer.title.length
      //                })
      //             })
      //          ) {
      //             correct_tests++
      //          } else {
      //             this.$buefy.toast.open(toastDanger('Нельзя опубликовать курс с пустым тестом'))
      //             isValid = false
      //             return
      //          }
      //       }
      //    }
      // })
      // if (correct_tests === all_tests) {
      //    isValid = true
      // }
      //}

      // if (isValid || !newStatus) {
      //    this.courseInfo.status = newStatus
      //    this.saveCourse()
      // }
    }
  }
}
</script>
